module.exports = __webpack_public_path__ + "media/assets/our_vision_banner-86c99b1c00cb1ee15eccf20aad40e65b.jpg";